import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CitiesWithStates } from "app/_models/cities-with-states";
import { States } from "app/_models/states";
import { CommonservicesService } from "app/_services/commonservices.service";
import { StateService } from "app/_services/state.service";
import { ToastrService } from "ngx-toastr";
declare const swal: any;

@Component({
  selector: "app-edit-city",
  templateUrl: "./edit-city.component.html",
})

export class EditCityComponent  implements OnInit{
  editCityForm: FormGroup;
  states: States[];
  state: States;
  editCity: CitiesWithStates;

  constructor(
    private readonly fb: FormBuilder,
    private readonly toastr: ToastrService,
    private readonly stateService: StateService,
    private readonly dialogRef: MatDialogRef<EditCityComponent>,
    private readonly commonService: CommonservicesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.editCity = JSON.parse(JSON.stringify(data));
    this.getStates();
  }

  ngOnInit(): void {
    this.editCityForm = this.fb.group({
      stateId: [this.data.stateId, [Validators.required]],
      cityName: [
        this.data.cityName ?? "",
        [Validators.required, Validators.maxLength(50)],
      ],
    });
  }

  getStates() {
    this.stateService.getStates().subscribe((states) => {
      this.states = states;
      this.state = this.states.find(s => s.id === this.data.stateId)!;
    });
  }
  

  updateCity() {
    const stateId = this.editCityForm.value.stateId;
    const cityName = (this.editCityForm.value.cityName ?? "").trim();
    let errorMessage = "";
    if (!cityName) {
      errorMessage += "City Name is required.\n";
    }
    if (cityName.length > 50) {
      errorMessage += "City Name cannot be more than 50 characters.\n";
    }
    if (!stateId || stateId == 0) {
      errorMessage += "State is required.\n";
    }

    if (errorMessage) {
      swal({
        title: "",
        text: errorMessage,
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
      return;
    }

    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Update IT!",
    }).then((result) => {
      if (result === true) {
        let model = {
          cityId: this.editCity.cityId,
          cityName: cityName,
          stateId: stateId,
        };
        this.updateCityDetail(model);
      } else {
        this.toastr.info("result not saved");
      }
    });
  }
  close() {
    this.dialogRef.close(false);
  }

  updateCityDetail(model: any) {
    this.commonService.updateCity(model).subscribe(
      (data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          }).then(() => {
            // ✅ Now close after success feedback
            this.dialogRef.close(true);
          });
        }
      },
      (error) => {
        let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }

        swal({
          title: "",
          text: errorMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
  }
}
